import React, { cloneElement, ReactElement } from "react";
import { useTheme } from "styled-components";

interface LookIconProps {
  classic: ReactElement;
  newLook: ReactElement;
}

// Renders `newLook` for users who opted into the new look and `classic`
// otherwise. Extra props (e.g. the className antd adds to menu icons) are
// forwarded to the rendered icon.
const LookIcon = ({ classic, newLook, ...rest }: LookIconProps) => {
  const { isNewLook } = useTheme();
  const icon = isNewLook ? newLook : classic;
  return Object.keys(rest).length ? cloneElement(icon, rest) : icon;
};

export default React.memo(LookIcon);
